export default {
  ADDITIONAL_AUTHS: [
    { auth: 'official_document_enabled', locale: 'document.list.signer.officialDocument' },
    { auth: 'selfie_enabled', locale: 'document.list.signer.selfie' },
    { auth: 'handwritten_enabled', locale: 'document.list.signer.handwritten' },
    { auth: 'liveness_enabled', locale: 'document.list.signer.liveness' },
    { auth: 'facial_biometrics_enabled', locale: 'document.list.signer.facialBiometricsEnabled' },
  ],
};
